import DOMPurify from 'dompurify';

const setRelNoopener = (node: Element): void => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
};

export function sanitize(content: string): string {
  DOMPurify.addHook('afterSanitizeAttributes', setRelNoopener);
  try {
    return DOMPurify.sanitize(content);
  } finally {
    DOMPurify.removeHook('afterSanitizeAttributes', setRelNoopener);
  }
}
